<template>
  <div class="blindbox">
    <div
        :style="{
        backgroundImage: 'url(' + goodsDetail.blindBoxInfo.detailsBg + ')'
      }"
        class="blindbox_bg"
    >
      <fixed-header
          ref="header"
          :shareContent="shareContent"
          :weixinShare="true"
          title="商品详情"
      ></fixed-header>
      <div
          :style="{
          backgroundImage:
            'url(' + goodsDetail.blindBoxInfo.detailsButtonBg + ')'
        }"
          class="blindbox_detailbt"
          mg-stat-click
          mg-stat-custom="label=btn&cont=商品详情&direct=cntp"
          mg-stat-mod="goods_details"
          @click="showDetailPopus = true"
      ></div>
      <div
          :style="{
          backgroundImage: 'url(' + goodsDetail.blindBoxInfo.windowBg + ')'
        }"
          class="blindbox_window"
      >
        <div
            v-for="(item, index) in boxList"
            :key="index"
            :class="['blindbox_window_block', 'index' + index]"
        >
          <div
              :style="{
              backgroundImage:
                'url(' + goodsDetail.blindBoxInfo.boxImgOne + ')'
            }"
              class="blindbox_window_box1"
              isMobile="false"
              mg-stat-click
              mg-stat-custom="label=btn&cont=点击盲盒&direct=cntp"
              mg-stat-mod="box_list"
              @click="removeImg($event)"
          ></div>
          <div
              :style="{
              backgroundImage:
                'url(' + goodsDetail.blindBoxInfo.boxImgTwo + ')'
            }"
              class="blindbox_window_box2"
              isMobile="false"
              mg-stat-click
              mg-stat-custom="label=btn&cont=点击盲盒&direct=cntp"
              mg-stat-mod="box_list"
              @click="removeImg($event)"
          ></div>
          <div
              :style="{
              backgroundImage:
                'url(' + goodsDetail.blindBoxInfo.boxImgTwo + ')'
            }"
              class="blindbox_window_box3"
              isMobile="false"
              mg-stat-click
              mg-stat-custom="label=btn&cont=点击盲盒&direct=cntp"
              mg-stat-mod="box_list"
              @click="removeImg($event)"
          ></div>
          <div
              :style="{
              backgroundImage:
                'url(' + goodsDetail.blindBoxInfo.boxImgThree + ')'
            }"
              class="blindbox_window_box4"
              isMobile="false"
              mg-stat-click
              mg-stat-custom="label=btn&cont=点击盲盒&direct=cntp"
              mg-stat-mod="box_list"
              @click="removeImg($event)"
          ></div>
        </div>
        <div v-if="goodsPrice" class="blindbox_window_price">
          ¥{{ goodsPrice }}
        </div>
        <div
            :style="{
            backgroundImage: 'url(' + goodsDetail.blindBoxInfo.buttonImg + ')'
          }"
            class="blindbox_window_btname"
            mg-stat-click
            mg-stat-custom="label=btn&cont=随机买一个&direct=cntp"
            mg-stat-mod="box_random"
            @click="showSkuParams = true"
        ></div>
      </div>
    </div>
    <mt-popup
        v-model="showSkuParams"
        class="goods-detail__popup"
        position="bottom"
    >
      <sku-params
          :data="goodsDetail"
          :flashSaleInfo="{}"
          :isBlindBoxGoods="true"
          :isPointsGoods="false"
          :isPreSell="false"
          :preSellInfo="{}"
          :vipType="0"
          clickType="buyNow"
          @chang_num="getSelectGoodsNum"
          @close="showSkuParams = false"
      ></sku-params>
    </mt-popup>
    <mt-popup
        v-model="showDetailPopus"
        class="blindbox_detail"
        position="bottom"
    >
      <div class="blindbox_detail_title">
        盲盒详情
        <img
            class="blindbox_detail_close"
            src="~assets/img/icon/blindbox_detail_close.png"
            @click="showDetailPopus = false"
        />
      </div>
      <div
          class="blindbox_detail_desc"
          v-html="goodsDetail.goods.goodsContent"
      ></div>
    </mt-popup>
    <shake-blind-box
        v-if="showShakeBox"
        :detailData="goodsDetail.blindBoxInfo"
        @close="showShakeBox = false"
        @pay="
        showShakeBox = false;
        showSkuParams = true;
      "
    ></shake-blind-box>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import SkuParams from 'components/goods/SkuParams';
import ShakeBlindBox from 'components/goods/ShakeBlindBox';
import { getQueryParams } from 'utils';
import { setWeixinShare } from 'utils/weixin';
import MgStat from 'MgStat';
import * as goodsApis from 'apis/goods';
import _ from 'lodash';

export default {
  components: {
    FixedHeader,
    SkuParams,
    ShakeBlindBox,
  },
  data() {
    const { id: goodsId } = getQueryParams();
    return {
      goodsId: goodsId ? Number(goodsId) : 0, // 当前商品id
      boxList: [{ id: 1 }, { id: 2 }, { id: 3 }], // 三行
      shareContent: null, // 分享链接内容
      lastEl: null, // 点击盒子上一个元素
      showDetailPopus: false, // 显示商品详情开关
      showSkuParams: false, // 显示商品购买浮层开关
      showShakeBox: false, // 显示晃一晃开关
      nowGoodsNum: 0, // 当前购物车中数量
      goodsDetail: {
        // 商品详情数据
        filterSpec: {},
        goods: {},
        goodsImagesList: [],
        specGoodsPrice: {},
        blindBoxInfo: {},
      },
    };
  },
  async created() {
    await this.fetchDetail();
  },
  computed: {
    // 获取价格
    goodsPrice() {
      const {
        goodsDetail: {
          goods: { shopPrice, memberGoodsPrice },
        },
      } = this;
      return memberGoodsPrice || shopPrice || 0;
    },
  },
  watch: {
    showShakeBox: {
      handler(val) {
        if (val) {
          MgStat.send(
            'cv',
            {},
            {
              mod: 'c_stargoodspop',
            },
          );
        }
      },
    },
    showDetailPopus: {
      handler(val) {
        if (val) {
          MgStat.send(
            'cv',
            {},
            {
              mod: 'c_stargoodsdetailspop',
            },
          );
        }
      },
    },
    showSkuParams: {
      handler(val) {
        if (val) {
          MgStat.send(
            'cv',
            {},
            {
              mod: 'c_hwshoppingpop',
            },
          );
        }
      },
    },
  },
  methods: {
    // 获取商品详情
    async fetchDetail() {
      if (this.goodsId) {
        try {
          const data = await goodsApis.getGoodsDetail({ id: this.goodsId });
          if (!_.isEmpty(data)) {
            this.goodsDetail = data;
            this.setShare();
          }
        } catch (error) {
          const { message } = error;
          this.$toast(`获取盲盒商品详情失败:${message}`);
          if (typeof message === 'string' && message.indexOf('下架') !== -1) {
            this.$router.go(-1);
          }
        }
      } else {
        this.$toast('盲盒商品不存在');
        this.$router.go(-1);
      }
    },
    // 移动盒子
    removeImg(event) {
      const el = event.currentTarget;
      const flag = el.getAttribute('isMobile');
      if (this.lastEl && el !== this.lastEl) {
        this.lastEl.style.marginTop = '0px';
        this.lastEl.setAttribute('isMobile', 'false');
      }
      if (flag === 'false') {
        el.style.marginTop = '10px';
        el.setAttribute('isMobile', 'true');
      } else {
        this.showShakeBox = true;
      }
      this.lastEl = el;
    },
    // 页面分享
    setShare() {
      const url = window.location.href;
      const {
        goodsDetail: {
          goods: { goodsName, originalImg },
        },
      } = this;
      if (originalImg) {
        this.shareContent = {
          title: goodsName,
          shareDesc: '我在芒果好物活捉一只不错的商品,来看看',
          shareUrl: url,
          shareIcon: originalImg,
        };
        setWeixinShare(this.shareContent);
      }
    },
    // 购物车选中数量
    getSelectGoodsNum(val) {
      this.nowGoodsNum = val;
    },
  },
};
</script>

<style lang="scss">
.blindbox {
  height: 100%;
  box-sizing: border-box;

  &_bg {
    height: 1624px;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  &_detailbt {
    position: absolute;
    height: 46px;
    width: 120px;
    top: 49px;
    right: 0px;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &_window {
    position: absolute;
    height: 1114px;
    width: 750px;
    top: 190px;
    background-repeat: no-repeat;
    background-size: cover;

    &_block {
      display: flex;
      flex-wrap: nowrap;
      position: relative;
    }

    &_box1 {
      position: absolute;
      left: 86px;
      margin-right: 16px;
      height: 188px;
      width: 142px;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &_box2 {
      position: absolute;
      left: 244px;
      margin-right: 16px;
      height: 188px;
      width: 124px;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &_box3 {
      position: absolute;
      left: 383px;
      margin-right: 16px;
      height: 188px;
      width: 124px;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &_box4 {
      position: absolute;
      left: 523px;
      height: 188px;
      width: 142px;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &_price {
      position: absolute;
      height: 45px;
      line-height: 45px;
      width: 142px;
      top: 950px;
      left: 435px;
      font-size: 36px;
      font-family: Arial;
      font-weight: bold;
      color: rgba(109, 75, 233, 1);
      text-align: center;
      background: linear-gradient(
              180deg,
              rgba(255, 242, 91, 1),
              rgba(255, 212, 80, 1)
      );
      box-shadow: 0px 7px 9px 0px rgba(98, 70, 168, 0.38);
      border-radius: 23px;
      z-index: 1;
    }

    &_btname {
      position: absolute;
      top: 977px;
      left: 424px;
      width: 282px;
      height: 94px;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  &_detail {
    height: 885px;
    width: 100%;

    &_title {
      position: fixed;
      height: 80px;
      line-height: 90px;
      width: 100%;
      font-size: 30px;
      color: #4a4a4a;
      font-weight: 500;
      text-align: center;
      background: #fff;
      border-radius: 30px 30px 0px 0px;
    }

    &_close {
      height: 28px;
      width: 28px;
      margin: 20px 20px 0px 0px;
      float: right;
    }

    &_desc {
      height: 100%;
      overflow-y: scroll;
      margin-top: 80px;

      img {
        display: block;
        max-width: 100%;
        margin: 0 auto;
      }
    }
  }

  .index0 {
    top: 165px;
  }

  .index1 {
    top: 406px;
  }

  .index2 {
    top: 647px;
  }
}
</style>
